module.exports = __webpack_public_path__ + "img/placemat-batten-mockup.a320a924.jpg";